export default __webpack_public_path__ + "3b4a617c15ca335bd6a223132cafb200.png";